import type { MetaFunction } from "@remix-run/node";
import { getSeoMeta } from "~/utils/seo-meta";
import { SEOLayout } from "~/components/seo/SEOLayout";
import { CompareSeoPage } from "~/components/seo/CompareSeoPage";
import { COMPARE_SEO_CONFIG } from "~/utils/seo-compare-content";

export const meta: MetaFunction = () => {
  const content = COMPARE_SEO_CONFIG["spin-wheel-apps"];
  return getSeoMeta({
    title: content.title,
    description: content.description,
    url: "/compare/spin-wheel-apps",
  });
};

export default function CompareSpinWheelApps() {
  return (
    <SEOLayout>
      <CompareSeoPage content={COMPARE_SEO_CONFIG["spin-wheel-apps"]} />
    </SEOLayout>
  );
}
